import styled from '@emotion/styled';

import variables from 'theme/styles/vars';

export default styled.div`
    background-color: #000000;
    padding: 1.56em 0;

    .categories-list-header{
        color: #ffffff;
        margin: .5em .5em 1.7em;
        font-size: 1.3em;
        cursor: pointer;
        display: none;
        justify-content: space-between;

        .arrow-down {

        }
    }

    .form-articles-search {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 1em;

        .categories-list {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }

    .layout-forms-form {
        max-width: 33.5em;

        .input-icon-wrapper{
            position: relative;

            img{
                position: absolute;
                top: 50%;
                left: 5%;
                transform: translateY(-50%);
                height: 1.4em;
                z-index: 3;
            }
        }
    }

    .input-body {
        position: relative;

        &::before {
            content: url('/images/forms/search.svg');
            position: absolute;
            left: 1em;
            top: .8em;
        }

        input {
            text-indent: 2em;
        }
    }

    .title-categorie-list {
        color: #fff;
        font-weight: 600;
        margin-right: 1.4em;
    }

    .form-categories-list {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 1.2em;

        .form-categories-el {
            .layout-button {
                font-size: .9em;
                max-width: 9.9em;
                .button{
                    &:hover {
                        background-color: #10F5B0;
                        border-color: #10F5B0;
                        color: #000;
                        font-weight: 600;
                        text-decoration: none;
                    }
                }
            }

            .mobile-link {
                display: none;
            }

            &.current {
                text-decoration: underline;
            }
        }

        a {
            font-size: 1.1em;
            color: #ffffff;
            text-decoration: none;
        }
    }

    .form-mobile {
        display: none;
    }

    @media all and (max-width:${variables.tabletS}) {
        padding: 1.5em 0;

        .categories-list-header {
            display: flex;
            margin-left: 1em;
        }

        .form-articles-search {
            flex-wrap: wrap;
            justify-content: flex-start;
            display: none;

            &.visible {
                display: flex;
            }

            .layout-forms-form {
                display: none;
            }
        }

        .title-categorie-list {
            display: none;
        }

        .form-categories-list {
            padding: 0 0 1em;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;

            .form-categories-el{
                .layout-button {
                    display: none;
                }

                .mobile-link {
                    display: flex;

                    &:hover {
                        transform: scale(1.1);
                    }
                }
            }
        }

        .form-mobile {
            display: none;
            background-color: #ffffff;
            padding: 1em .5em;

            .layout-forms-form {
                margin: 0 auto;

                .input-icon-wrapper{
                    img{
                        left: .7em;
                    }
                }
            }
        }

        .form-categories-list {
            flex-wrap: wrap;
            justify-content: center;
            flex-direction: column;
            padding: 1em 0 2em 1em;

            &:first-of-type{
                padding-top: 0;
            }
        }
    }
`;